import { takeLatest, put, select } from 'redux-saga/effects';

import { getReport } from './moderationCrud';
import { REPORT_TYPES, REPORT_REASONS, STATUSES } from '../consts';

export const actionTypes = {
	SaveReports: '[Moderation] SaveReports',
	UpdateFilter: '[Moderation] UpdateFilter',
	UpdatePagination: '[Moderation] UpdatePagination',
	UpdateTotal: '[Moderation] UpdateTotal',
	UpdateReport: '[Moderation] UpdateReport',
	SetLoading: '[Moderation] SetLoading',
	BanUser: '[Moderation] BanUser',
	BanReport: '[Moderation] BanReport',
	BanReports: '[Moderation] BanReports',
	ToggleReportSelection: '[Moderation] ToggleReportSelection',
	SelectAll: '[Moderation] SelectAll',
	UnselectAll: '[Moderation] UnselectAll',
};

export const pagination = {
	page: 1,
	size: 20,
};

export const initialReportState = {
	reports: [],
	filter: {
		reportType: REPORT_TYPES[0].value,
		reportReason: REPORT_REASONS[0].value,
		status: STATUSES[0].value,
	},
	selected: [],
	pagination,
	total: 0,
	loading: false,
};

export const reducer = (state = initialReportState, action) => {
	switch (action.type) {
		case actionTypes.SaveReports:
			return {
				...state,
				reports: action.payload,
				loading: false,
			};
		case actionTypes.UpdateFilter:
			return {
				...state,
				filter: action.payload,
			};
		case actionTypes.SetLoading:
			return {
				...state,
				loading: action.payload,
			};
		case actionTypes.BanUser:
			return {
				...state,
				reports: [...state.reports].map((r) => {
					if (r?.comment?.post?.user?._id === action.payload.userId) {
						r.comment.post.user.banned = true;
					} else if (r?.post?.user?._id === action.payload.userId) {
						r.post.user.true = true;
					}
					return r;
				}),
			};
		case actionTypes.UpdatePagination:
			return {
				...state,
				pagination: action.payload,
				selected: [],
			};
		case actionTypes.BanReport:
			const reports = [...state.reports];
			const report = reports.find((r) => r._id === action.payload.id);
			report.closed = true;
			report.banInfo = {
				accept: action.payload.action === 'accept',
			};
			return {
				...state,
				reports,
			};
		case actionTypes.BanReports:
			return {
				...state,
				reports: state.reports.map((r) => {
					if (state.selected.includes(r.id)) {
						r.closed = true;
						r.banInfo = {
							accept: action.payload === 'accept',
						};
					}
					return r;
				}),
				selected: [],
			};
		case actionTypes.UpdateTotal:
			return {
				...state,
				total: action.payload,
			};
		case actionTypes.ToggleReportSelection:
			if (state.selected.includes(action.payload)) {
				return {
					...state,
					selected: state.selected.filter((s) => s !== action.payload),
				};
			} else {
				return {
					...state,
					selected: [...state.selected, action.payload],
				};
			}
		case actionTypes.SelectAll:
			return {
				...state,
				selected: state.reports.filter((r) => !r.closed).map((r) => r.id),
			};
		case actionTypes.UnselectAll:
			return {
				...state,
				selected: [],
			};
		default:
			return state;
	}
};

export const actions = {
	saveReports: (payload) => ({ type: actionTypes.SaveReports, payload }),
	updateFilter: (payload) => ({ type: actionTypes.UpdateFilter, payload }),
	updatePagination: (payload) => ({ type: actionTypes.UpdatePagination, payload }),
	updateTotal: (payload) => ({ type: actionTypes.UpdateTotal, payload }),
	setLoading: (payload) => ({ type: actionTypes.SetLoading, payload }),
	updateReport: (payload) => ({ type: actionTypes.UpdateReport, payload }),
	banUser: (payload) => ({ type: actionTypes.BanUser, payload }),
	banReport: (payload) => ({ type: actionTypes.BanReport, payload }),
	toggleReportSelection: (payload) => ({ type: actionTypes.ToggleReportSelection, payload }),
	selectAll: (payload) => ({ type: actionTypes.SelectAll, payload }),
	unselectAll: (payload) => ({ type: actionTypes.UnselectAll, payload }),
	banReports: (payload) => ({ type: actionTypes.BanReports, payload }),
};

export function* saga() {
	yield takeLatest(actionTypes.UpdateFilter, function* updateData() {
		yield put(actions.updatePagination({ ...pagination }));
	});
	yield takeLatest(actionTypes.UpdatePagination, function* updateData() {
		yield put(actions.setLoading(true));
		const {
			moderation: { pagination: paging, filter: moderationFilter },
			merchants: { filter },
		} = yield select();
		const { data, pagination } = yield getReport({ ...filter, ...moderationFilter, ...paging });
		yield put([actions.saveReports(data), actions.updateTotal(pagination ? pagination.total : 0)]);
	});
}
